import { About as AboutSection, Cta, Testimonials } from "@components/sections";
import { Container } from "@components/ui/Container";
import { Section } from "@components/ui/Section";
import { company } from "@data/company";
import styles from "./About.module.css";

/* ──────── Iconos ──────── */
const IconUsers = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

const IconScale = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3v18M5 8h14M5 8 2 16h6L5 8zm14 0-3 8h6l-3-8zM2 16a3 3 0 0 0 6 0M16 16a3 3 0 0 0 6 0M9 21h6" />
  </svg>
);

const IconHeart = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const IconShield = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const IconAward = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="8" r="7" />
    <path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.12" />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IconFile = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <path d="M14 3v6h6" />
  </svg>
);

const IconHandshake = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M11 17 9 19a2.83 2.83 0 0 1-4-4l5-5 5 5" />
    <path d="m21 3-6 6-5-5" />
    <path d="m18 8 4-4" />
    <path d="M13 17a2.83 2.83 0 0 0 4 0l3-3-5-5-5 5" />
  </svg>
);

const IconCertificate = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="9" r="6" />
    <path d="m8.5 13.5-1.5 8L12 19l5 2.5-1.5-8" />
  </svg>
);

const IconBuilding = () => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <path d="M9 22v-4h6v4M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01" />
  </svg>
);

const reasons = [
  {
    Icon: IconUsers,
    title: "Productores matriculados",
    body: "Profesionales con matrícula vigente en la Superintendencia de Seguros de la Nación (SSN).",
  },
  {
    Icon: IconScale,
    title: "Independientes",
    body: "Trabajamos con las principales aseguradoras del país y comparamos por vos. Sin atajos comerciales.",
  },
  {
    Icon: IconClock,
    title: "Respuesta en 24 hs",
    body: "Cotizaciones, consultas y siniestros se atienden el mismo día o al siguiente hábil.",
  },
  {
    Icon: IconHeart,
    title: "Atención humana",
    body: "Cada cliente tiene un productor asignado, no un call center. Vos elegís el canal.",
  },
  {
    Icon: IconShield,
    title: "Acompañamiento en siniestros",
    body: "Denuncia, peritaje, recursos y cobro: estamos durante todo el proceso.",
  },
  {
    Icon: IconAward,
    title: "+30 años de experiencia",
    body: "Tres décadas atendiendo personas, familias, comercios y pymes en el país.",
  },
];

const steps = [
  {
    Icon: IconPhone,
    title: "Contactanos",
    body: "Por WhatsApp, teléfono o formulario. Nos contás qué necesitás.",
  },
  {
    Icon: IconFile,
    title: "Cotizamos",
    body: "Comparamos coberturas entre las principales aseguradoras y te enviamos propuestas claras.",
  },
  {
    Icon: IconHandshake,
    title: "Asesoramos",
    body: "Te ayudamos a entender cada opción y elegir la que se ajuste a tu perfil y presupuesto.",
  },
  {
    Icon: IconShield,
    title: "Te acompañamos",
    body: "Después de la contratación seguimos cerca para renovaciones, cambios y siniestros.",
  },
];

export default function AboutPage() {
  return (
    <>
      {/* ───────────── HERO ───────────── */}
      <section className={styles.hero}>
        <Container>
          <div className={styles.heroGrid}>
            <div>
              <span className={styles.eyebrow}>Nosotros</span>
              <h1 className={styles.heroTitle}>
                Acompañamos cada decisión con <em>criterio profesional</em>.
              </h1>
              <p className={styles.heroLead}>
                {company.fullName} nació para cambiar la forma de contratar un
                seguro: con asesoría real, productores matriculados y atención
                humana. Trabajamos con las principales aseguradoras del país para
                que tengas siempre la mejor cobertura al mejor precio.
              </p>
              <div className={styles.heroChips}>
                <span className={styles.chip}>
                  <span className={styles.chipDot} /> +30 años en el mercado
                </span>
                <span className={styles.chip}>
                  <span className={styles.chipDot} /> 2 sucursales
                </span>
              </div>
            </div>

            <div className={styles.heroVisual} aria-hidden>
              <div className={styles.visualHeading}>En números</div>
              <div className={styles.visualGrid}>
                <div className={styles.visualItem}>
                  <strong>+30</strong>
                  <span>Años de experiencia</span>
                </div>
                <div className={styles.visualItem}>
                  <strong>+5.000</strong>
                  <span>Clientes activos</span>
                </div>
                <div className={styles.visualItem}>
                  <strong>24h</strong>
                  <span>Para cotizar</span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* ───────────── ABOUT (valores) ───────────── */}
      <AboutSection withHeader={false} />

      {/* ───────────── POR QUÉ ELEGIRNOS ───────────── */}
      <Section
        eyebrow="Por qué elegirnos"
        align="center"
        title="Diferenciales que nos hacen distintos"
        description="No vendemos seguros, te asesoramos para que elijas el mejor."
        background="alt"
      >
        <Container>
          <div className={styles.reasons}>
            {reasons.map((r) => (
              <div key={r.title} className={styles.reason}>
                <div className={styles.reasonIcon}>
                  <r.Icon />
                </div>
                <h4>{r.title}</h4>
                <p>{r.body}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* ───────────── CÓMO TRABAJAMOS ───────────── */}
      <Section
        eyebrow="Cómo trabajamos"
        align="center"
        title="Nuestro proceso, en 4 pasos"
        description="Sencillo, transparente y sin sorpresas."
      >
        <Container>
          <div className={styles.steps}>
            {steps.map((s) => (
              <div key={s.title} className={styles.step}>
                <div className={styles.stepIcon}>
                  <s.Icon />
                </div>
                <h4>{s.title}</h4>
                <p>{s.body}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* ───────────── COMPLIANCE / MATRÍCULA ───────────── */}
      <Section background="alt">
        <Container>
          <div className={styles.compliance}>
            <div className={styles.complianceHeader}>
              <h2 className={styles.complianceTitle}>
                Cumplimiento normativo y matrícula vigente
              </h2>
              <p className={styles.complianceBody}>
                Operamos en cumplimiento de la Ley 22.400 y la Resolución SSN
                vigente. Cada productor de nuestra red está matriculado en la
                Superintendencia de Seguros de la Nación.
              </p>
            </div>
            <div className={styles.complianceList}>
              <div className={styles.complianceItem}>
                <div className={styles.complianceBadge}>
                  <IconCertificate />
                </div>
                <div>
                  <strong>PAS matriculados (SSN)</strong>
                  <span>Productores Asesores con matrícula nacional vigente.</span>
                </div>
              </div>
              <div className={styles.complianceItem}>
                <div className={styles.complianceBadge}>
                  <IconBuilding />
                </div>
                <div>
                  <strong>Organización registrada</strong>
                  <span>Inscriptos como organización de productores ante la SSN.</span>
                </div>
              </div>
              <div className={styles.complianceItem}>
                <div className={styles.complianceBadge}>
                  <IconShield />
                </div>
                <div>
                  <strong>Datos protegidos</strong>
                  <span>Cumplimos con la Ley 25.326 de protección de datos personales.</span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* ───────────── TESTIMONIOS ───────────── */}
      <Testimonials />

      {/* ───────────── CTA específico ───────────── */}
      <Cta
        title="Conocenos en persona"
        body="Coordinamos una reunión en cualquiera de nuestras sucursales o virtual. Sin compromiso."
        primaryLabel="Agendar reunión"
        secondaryLabel="Llamar"
      />
    </>
  );
}

